export default __webpack_public_path__ + "static/media/colorWhatIfCurrent.7038c000.svg";